import { Message } from "@/types/messageService";
import { convertToUTC, formatDate } from "./dateUtils";

export const getInitialsFromName = (name: string | null | undefined): string => {
  if (!name) return "";
  return name[0].toUpperCase();
};

export const stringToColor = (string: string): string => {
  let hash = 0;
  let i;
  for (i = 0; i < string?.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = "#";
  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
};

export const stringAvatar = (name: string): { bgcolor: string } => {
  return {
    bgcolor: stringToColor(name),
  };
};

export const groupMessages = (messages: Message[]): [string, Message[]][] => {
  const groupedMessages: { [key: string]: Message[] } = {};
  const groups: [string, Message[]][] = [];

  messages.forEach(message => {
    const date = formatDate(convertToUTC(message.created_at));
    const source = message.source;
    const groupKey = `${date} - ${source}`;

    if (!groupedMessages[groupKey]) {
      groupedMessages[groupKey] = [];
      groups.push([groupKey, groupedMessages[groupKey]]);
    }

    groupedMessages[groupKey].push(message);
  });

  return groups;
};

export const isValidNumericInput = (inputValue: string): boolean => {
  return /^[0-9]+$/.test(inputValue);
};

export function extractFolderAndFileName(url: string) {
  const decodedUrl = decodeURIComponent(url);
  const regex = /\/([^/]+)\/([^/]+)$/;
  const match = decodedUrl.match(regex);
  if (match) {
    return {
      folderName: match[1],
      fileName: match[2],
    };
  } else {
    return {
      folderName: null,
      fileName: null,
    };
  }
}

export function validateFileType(files: File[], acceptTypes: string) {
  if (!acceptTypes || !files.length) {
    console.log("AcceptTypes or files length is empty.");
    return { isValid: true, message: "" };
  }
  return { isValid: true, message: "" };
}

export const appendDocumentLinkAsMarkdown = (messageToSend: string, documentLink?: string): string => {
  if (documentLink) {
    const decodedDocumentLink = decodeURIComponent(documentLink);
    const fileName = decodedDocumentLink.split("/").pop();
    if (fileName) {
      const fileExtension = fileName.split(".").pop()?.toLowerCase();
      if (fileExtension === "pdf") {
        return `${messageToSend}\n\n[${fileName}](${decodedDocumentLink})`;
      } else {
        return `${messageToSend}\n\n![${fileName}](${decodedDocumentLink})`;
      }
    }
  }
  return messageToSend;
};

export const disableKeyboardDeletion = (event: React.KeyboardEvent<HTMLDivElement>) => {
  if (["Backspace", "Delete", "ArrowLeft"].includes(event.key)) {
    event.stopPropagation();
  }
};

export function isFileSizeWithinLimit(file: File, maxSizeMB: number) {
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  return file.size <= maxSizeBytes;
}

export function downloadFile(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
